/**
 * `exactOptionalPropertyTypes` (packages/config/typescript/tsconfig.base.json)
 * forbids passing `undefined` explicitly for an optional prop — it must be
 * *absent*, not present-with-undefined. React Hook Form's `error?.message`
 * is typed `string | undefined`, so `<Field error={errors.x?.message} />`
 * fails to typecheck under that rule. This spreads the prop in only when a
 * message actually exists.
 */
export function whenDefined<K extends string, V>(
  key: K,
  value: V | undefined,
): Record<K, V> | Record<string, never> {
  return value !== undefined ? ({ [key]: value } as Record<K, V>) : {};
}
